module.exports = __webpack_public_path__ + "img/30f12.da39a94d.jpg";